import { TouchEvent, useRef } from 'react';

interface IUseSwipe {
  onSwipeLeft?: () => void;
  onSwipeRight?: () => void;
  minSwipeDistance?: number;
}
export const useSwipeDirection = ({
  onSwipeLeft,
  onSwipeRight,
  minSwipeDistance = 50,
}: IUseSwipe) => {
  const touchStart = useRef<number | null>(null);
  const touchEnd = useRef<number | null>(null);

  const onTouchStart = (e: TouchEvent<HTMLElement>) => {
    touchEnd.current = null;
    touchStart.current = e.targetTouches[0].clientX;
  };

  const onTouchMove = (e: TouchEvent<HTMLElement>) =>
    (touchEnd.current = e.targetTouches[0].clientX);

  const onTouchEnd = () => {
    if (!touchStart.current || !touchEnd.current) return;
    const distance = touchStart.current - touchEnd.current;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isLeftSwipe && onSwipeLeft) {
      onSwipeLeft();
    }
    if (isRightSwipe && onSwipeRight) {
      onSwipeRight();
    }
  };
  return { onTouchEnd, onTouchMove, onTouchStart };
};
